import './ProjectDetail.css';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import projectList from '../projectList';
import Carousel from '../components/Carousel';

function ProjectDetail() {
    const { id } = useParams();
    const project = projectList.find(p => p.id === parseInt(id));

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!project) return <div className="detail-page"><h2>Proje bulunamadı.</h2></div>;

    return (

        <div>
            <div className="detail-page">
                <div className="detail-container">
                    <div className="inner-cont-1">
                        <div className="inner-cont-2">
                            <img src={project.image} alt={project.title} className="detail-image" />
                            <div className="textcont">
                                <h1 className="detail-title">{project.title}</h1>
                                <a href={`${project.projeLink}`} target="_blank" className="projeLink">{project.projeLink}</a>
                            </div>
                        </div>
                    </div>
                    <p className="detail-desc">{project.desc}</p>
                    <div className="kullanilanTeknolojiler">
                        {project.kullanilanTeknolojiler.map((tech, index) => (
                            <span key={index} className="teknoloji-badge">{tech}</span>
                        ))}
                    </div>
                    <Carousel className="projeImages" images={project.projeImages} />
                </div>

            </div>
        </div>

    );
}

export default ProjectDetail;
